<template>
  <div>
    <el-dialog
      width="100%"
      :visible="true"
      :show-close="false"
    >
      <ReminderText></ReminderText>
      <span slot="footer">
        <el-button type="primary" @click="close" round
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ReminderText from './reminderText.vue';
export default {
  components: {
    ReminderText,
  },  
  methods: {  
    close(){
      this.$emit('close-reminder');
    },  
  }
};
</script>
<style scoped>
p {
  line-height: 24px;
}
</style>
